// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import DebitLaborPanel from '../../../partial-debit/components/debit-labor-panel/debit-labor-panel';
import DebitOtherCreditPanel from '../../../partial-debit/components/debit-other-credits-panel/debit-other-credit-panel';
import DebitPartsPanel from '../../../partial-debit/components/debit-parts-panel/debit-parts-panel';
import DebitSpecialAllowancePanel from '../../../partial-debit/components/debit-special-allowance-panel/debit-special-allowance-panel';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import PercentageInfoScreen from '../../../percentage-debit/components/percentage-screen/percentage-info-screen';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {buildNumber} from '../../../../shared/services/build-number';

function handleCommentsChange(event) {

    this.onCommentsChange(event.target.value);

}

function handleConfirmation() {

    this.onConfirmation(this.debit);

}

const DebitModalBody = props => {

    const debitWithAdjustedItems = new Debit({
        ...props.debit,
        partialDebit: props.debit.getAdjustedItems()
    });

    return (
        <section className='debit-modal-body'>
            <div className='row'>
                <LabeledString
                    className='claim-number'
                    data={props.debit.claimNumber}
                    label='CLAIM_NUMBER'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='claim-type'
                    data={props.debit.claimType.key === 'ZZMK' ?
                    props.debit.claimSubType.value :
                    props.debit.claimType.value
                }
                    label='CLAIM_TYPE'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='responsible-account'
                    data={buildDealer(props.debit.responsibleAccount)}
                    label='RESPONSIBLE_ACCOUNT'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='pin'
                    data={props.debit.pin}
                    label='PIN'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='net-amount-paid'
                    data={buildNumber(props.debit.netAmountPaid)}
                    label='NET_AMOUNT_PAID'
                />
            </div>
            {
                props.debitType === 'PERCENTAGE' &&
                <div>
                    <PercentageInfoScreen
                        amountDebit={props.amountDebit}
                        netAmountPaid={props.debit.netAmountPaid}
                    />
                </div>
            }
            {
                props.debitType === 'PARTIAL' && props.debit.claimType.key !== 'ZSPA' &&
                    <div>
                        <DebitPartsPanel
                            isEditable={false}
                            parts={debitWithAdjustedItems.getParts()}
                        />
                        <DebitLaborPanel
                            isEditable={false}
                            labors={debitWithAdjustedItems.getLabors()}
                        />
                        <DebitOtherCreditPanel
                            credits={debitWithAdjustedItems.getOtherCredits()}
                            isEditable={false}
                        />
                    </div>
            }
            {
                props.debitType === 'PARTIAL' && props.debit.claimType.key === 'ZSPA' &&
                    <DebitSpecialAllowancePanel
                        isEditable={false}
                        specialAllowancePartialDebit={props.debit.specialAllowancePartialDebit}
                    />
            }
            <div className='row'>
                <span className='data-label'>
                    <FormattedMessage id='REASON_FOR_DEBIT'/>
                </span>
                <textarea
                    className='reason-for-debit'
                    maxLength='255'
                    onChange={props::handleCommentsChange}
                >
                </textarea>
            </div>
            <div className='button-group'>
                <button
                    className='primary'
                    disabled={!props.debit.reasonForDebit}
                    onClick={props::handleConfirmation}
                >
                    <FormattedMessage id='CONFIRM'/>
                </button>
            </div>
        </section>
    );

};

DebitModalBody.displayName = 'DebitModalBody';
DebitModalBody.propTypes = {
    amountDebit: PropTypes.number.isRequired,
    debit: PropTypes.instanceOf(Debit).isRequired,
    debitType: PropTypes.string.isRequired,
    onCommentsChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired
};

export default DebitModalBody;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/debit-modal/debit-modal-body.js